import React, { useRef } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import PolicyConsent from './PolicyConsent';

const GuestCheckoutModal = ({ 
  show, 
  onHide, 
  onContinue, 
  loading, 
  error,
  captchaToken,
  onCaptchaChange,
  acceptedTerms,
  acceptedPrivacy,
  viewedTerms,
  viewedPrivacy,
  onPolicyChange
}) => {
  const recaptchaRef = useRef(null);

  const canContinue = captchaToken && acceptedTerms && acceptedPrivacy && viewedTerms && viewedPrivacy;

  const handleContinue = () => {
    if (!canContinue) return;
    onContinue(captchaToken);
  };

  const handleHide = () => {
    recaptchaRef.current && recaptchaRef.current.reset();
    onHide();
  };

  return (
    <Modal show={show} onHide={handleHide} centered size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Complete Guest Checkout</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        
        <div className="mb-3">
          <h6>Verify You're Human</h6>
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
            onChange={onCaptchaChange}
          />
          {captchaToken && <div className="text-success small mt-2">✓ Captcha verified</div>}
        </div>

        <div className="mb-3">
          <PolicyConsent
            required
            initial={{ viewedPrivacy, acceptedPrivacy, viewedTerms, acceptedTerms }}
            onChange={onPolicyChange}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleHide} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleContinue}
          disabled={!canContinue || loading}
        >
          {loading ? 'Processing...' : 'Continue to Shipping'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GuestCheckoutModal;
